import type { CompareVisitItem } from "@/utils/parlorCompareVisitStorage";

/**
 * #334 찾아보신 N곳 비용 알아보기 리드. postLeadV2 사람용 본문.
 * 오인지 경고는 Same 재방문 모달(#318)과 같은 층.
 */
export function buildParlorVisitedListLeadMessage({
  parlors,
  mournerCount,
}: {
  parlors: CompareVisitItem[];
  mournerCount: string;
}): string {
  const lines = parlors.map((p) => {
    const price =
      typeof p.minPriceManwon === "number"
        ? ` (최소 ${p.minPriceManwon.toLocaleString("ko-KR")}만원~)`
        : "";
    return `- *${p.name}*${price}`;
  });
  const names = parlors.map((p) => p.name).join("', '");

  return `질문 내용 : *찾아보신 장례식장 ${parlors.length}곳 비용 문의*

식장 상세에서 서로 다른 식장 2곳 이상을 본 고객이
「찾아보신 N곳의 비용 알아보기」로 접수한 리드입니다.

찾아보신 식장:
${lines.join("\n")}

예상 조문객수 : *${mournerCount}*
-----
⚠️ 장례식장 오인지 가능성이 높은 고객입니다.
고이가 아닌 '${names}'에서 직접 비용 안내가 가능한지 궁금한 케이스일 가능성이 높습니다.
상황 확인 후, 추가적인 세일즈 부탁드립니다.`;
}
